
























































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { mapState, mapActions } from 'vuex';
import tenantsTableBody from '@/views/tenants/components/TBody';

const Tenants = namespace('tenants');

@Component({})
export default class TenantList extends Vue {
  private tableBody: unknown = {
    component: tenantsTableBody
  }
  
  @Tenants.State
  private list!: ServerList
  
  @Tenants.Action('list')
  private filter!: (params: QueryParams) => Promise<ServerList>
  
  // private newQuestion!: (obj: { data: Question }) => Question
  mounted () {
    console.log(window.Tenants = Tenants);
    console.log(window.$ctrl = this)
  }
}
